__turbopack_context__.v({
  "card": "style-module-scss-module__8G0afa__card",
  "cardDescription": "style-module-scss-module__8G0afa__cardDescription",
  "cardFooter": "style-module-scss-module__8G0afa__cardFooter",
  "cardText": "style-module-scss-module__8G0afa__cardText",
  "cardTitle": "style-module-scss-module__8G0afa__cardTitle",
  "container": "style-module-scss-module__8G0afa__container",
  "crowSwiper": "style-module-scss-module__8G0afa__crowSwiper",
  "heading": "style-module-scss-module__8G0afa__heading",
  "next": "style-module-scss-module__8G0afa__next",
  "pagination": "style-module-scss-module__8G0afa__pagination",
  "paginationHidden": "style-module-scss-module__8G0afa__paginationHidden",
  "prev": "style-module-scss-module__8G0afa__prev",
  "section": "style-module-scss-module__8G0afa__section",
  "sliderWrap": "style-module-scss-module__8G0afa__sliderWrap",
  "subtitle": "style-module-scss-module__8G0afa__subtitle",
  "swiper": "style-module-scss-module__8G0afa__swiper",
  "title": "style-module-scss-module__8G0afa__title",
});
